import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledOrderBySelector = styled('div')`
  .icon {
    margin-right: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .direction-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    padding: 0 4px;
    border: none;
    background: none;
    cursor: pointer;
    color: ${(props) => props.theme.colorTextSecondary};
    border-radius: 4px;
    transition: color 0.2s;
  }

  .direction-toggle:hover {
    color: ${(props) => props.theme.colorPrimary};
  }

  .ant-select-dropdown div {
    width: 100% !important;
    box-sizing: border-box;
  }

  .ant-select-item {
    min-width: 142px;
  }

  .ant-select-dropdown-hidden {
    display: none !important;
  }

  .rc-virtual-list-holder div {
    align-items: start !important;
  }

  .ant-select-arrow {
    inset-inline-end: 0 !important;
  }

  .ant-select-selection-item {
    display: none !important;
  }
`;

export const StyledPageSizeSelector = styled('div')`
  .text {
    margin-right: -7px;
  }

  .ant-select {
    .ant-select-arrow {
      width: 20px;
    }
  }

  .ant-select-item {
    min-width: 142px;
  }

  .ant-select-dropdown-hidden {
    display: none !important;
  }
`;

export const StyledTopCategorySelector = styled('div')`
  border: 1px solid ${(props) => props.theme};
  padding: 15px;

  .ant-tooltip {
    display: none;
  }

  .btn {
    max-width: 200px;
    display: flex;
    font-size: 14px;
  }

  .category {
    display: flex;
    flex-direction: column;

    .preview {
      max-width: 500px;
      max-height: 500px;
      margin-bottom: 12px;

      .ant-image {
        width: 467px;
        height: 194px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
      }

      .ant-image-img {
        width: 100%;
        object-fit: contain;
        object-position: center;
        display: block;
      }
    }

    .ant-upload-list-item-container {
      max-width: 200px;
      overflow: hidden;
    }

    .ant-form-item {
      min-width: 200px;
      max-width: 200px;
      margin-bottom: 0;

      .ant-select-dropdown {
        position: absolute;
        top: 20px;
      }
    }

    .validation-text {
      margin: 12px 0;
    }
  }

  .initial-value {
    color: ${(props) => props.theme.colorText} !important;
  }
`;

export const StyledCategorySelector = styled('div')`
  .drop-down {
    min-width: 245px;
    min-height: 41px;
    max-width: 255px;

    @media (max-width: ${breakpoints.lg}px) {
      min-width: unset;
      max-width: unset;
      width: 100%;
    }
  }

  .ant-select-selection-item {
    font-family: ${(props) => props.theme.fontText};
  }

  .ant-select-item-option-content {
    font-family: ${(props) => props.theme.fontText};
  }

  .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
    min-height: 41px;
  }

  :where(.ant-select).ant-select-outlined:not(.ant-select-disabled):not(
      .ant-select-customize-input
    ):not(.ant-pagination-size-changer):hover
    .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }
  .displayFlex {
    display: flex;
    gap: 10px;
  }
  .admin {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    gap: 10px;
    font-family: ${(props) => props.theme.fontText};

    @media (max-width: ${breakpoints.lg}px) {
      .category-selector-item {
        width: 100%;
      }
    }
  }

  @media (max-width: ${breakpoints.lg}px) {
    .category-sel-wrap {
      margin-top: 8px;
    }
  }

  .user {
    .drop-down {
      margin-bottom: 5px;
    }
  }
`;

export const StyledLocationSelector = styled('div')`
  margin-bottom: 18px;

  .drop-down {
    min-width: 245px;
    min-height: 41px;
    max-width: 255px;
  }

  .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }

  :where(.ant-select).ant-select-outlined:not(.ant-select-disabled):not(
      .ant-select-customize-input
    ):not(.ant-pagination-size-changer):hover
    .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }
`;

export const StyledDistanceRadiusSelector = styled('div')`
  margin-bottom: 18px;

  .form-title {
    padding: 0 8px 8px 0;
    font-weight: 600;
    font-size: 16px;
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .distance-radius-input {
    width: 100%;

    .ant-input-number-input-wrap {
      min-height: 41px;
    }

    .ant-input-number-group-wrapper {
      min-height: 41px;
      border-radius: 5px;
      border: 1px solid ${(props) => props.theme.softSlateBlue};
      background-color: ${(props) => props.theme.lightGrey};

      .ant-input-number-outlined,
      .ant-input-number-group-addon,
      .ant-input-number {
        border: none;
        background-color: transparent;
        box-shadow: none;
      }
    }

    .ant-input-number-group-wrapper:hover {
      border-color: ${(props) => props.theme.borderBottom};
    }

    .ant-input-number-group-wrapper:focus-within {
      border-color: ${(props) => props.theme.softSlateBlue};
      box-shadow: 0 0 0 2px ${(props) => props.theme.softSlateBlue};
    }

    @media (max-width: ${breakpoints.lg}px) {
      .ant-input-number-group-wrapper:focus-within {
        border-color: ${(props) => props.theme.softSlateBlue};
        box-shadow: none;
      }
    }
  }
`;

export const StyledLocationRadiusSelector = styled('div')`
  margin-bottom: 18px;

  .drop-down {
    min-width: 245px;
    min-height: 41px;
    max-width: 255px;
  }

  .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }

  :where(.ant-select).ant-select-outlined:not(.ant-select-disabled):not(
      .ant-select-customize-input
    ):not(.ant-pagination-size-changer):hover
    .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }

  .ant-form-item {
    margin-bottom: 20px;
  }

  .location-distance-radius-input {
    width: 100%;
    border-radius: 8px;
  }
`;

export const StyledAddressSelector = styled('div')`
  margin-bottom: 18px;

  .ant-form-item {
    margin-bottom: 0;
  }

  .drop-down {
    min-width: 245px;
    min-height: 41px;
    max-width: 255px;
  }

  .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }

  :where(.ant-select).ant-select-outlined:not(.ant-select-disabled):not(
      .ant-select-customize-input
    ):not(.ant-pagination-size-changer):hover
    .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }

  .address-autocomplete {
    width: 100%;

    .ant-select-selection-search-input {
      font-size: 16px;
    }

    &.selected {
      .ant-select-selector {
        background-color: ${(props) => props.theme.softShadowGray} !important;
      }

      .ant-select-clear {
        opacity: 1;
        color: ${(props) => props.theme.stepArrowColor};
      }
    }
  }
`;

export const StyledFarmsSelector = styled('div')`
  font-family: ${(props) => props.theme.fontText};
  margin-bottom: 18px;

  .drop-down {
    min-width: 245px;
    min-height: 41px;
    max-width: 255px;
  }

  .form-title {
    padding-top: 0;
  }

  .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }

  :where(.ant-select).ant-select-outlined:not(.ant-select-disabled):not(
      .ant-select-customize-input
    ):not(.ant-pagination-size-changer):hover
    .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }
`;

export const StyledSortSelector = styled('div')`
  .sort-dropdown-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 4px 12px;
    border-radius: 4px;
    transition: all 0.2s;
    user-select: none;

    &:hover {
      border-color: ${(props) => props.theme.colorPrimary};
      color: ${(props) => props.theme.colorPrimary};
    }

    .sort-dropdown-label {
      font-size: 14px;
    }

    .sort-dropdown-arrow {
      font-size: 12px;
    }
  }

  .sort-menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-width: 150px;

    .sort-menu-label {
      font-size: 14px;
    }

    .sort-menu-icon {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: ${(props) => props.theme.colorPrimary};
    }
  }
`;

export const StyledLocationRadiusSelectorWithAmk = styled('div')`
  margin-bottom: 18px;

  .ant-form-item {
    margin-bottom: 20px;
  }

  .selected-input {
    min-height: 41px;
    border-color: ${(props) => props.theme.borderBottom};

    .anticon-close {
      padding: 10px;
      cursor: pointer;
      color: ${(props) => props.theme.colorTextSecondary};

      &:hover {
        color: ${(props) => props.theme.colorText};
      }
    }
  }

  .location-distance-radius-input {
    width: 100%;
    border-radius: 8px;
  }

  .location-autocomplete {
    width: 100%;

    .ant-input-affix-wrapper {
      min-height: 41px;
      border-color: ${(props) => props.theme.borderBottom};

      &:hover,
      &:focus,
      &:focus-within {
        border-color: ${(props) => props.theme.borderBottom};
      }
    }

    .anticon-close,
    .dropdown-arrow {
      font-size: 15px;
      cursor: pointer;
      margin-right: 10px;
    }
  }

  .loading-indicator {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 2px solid ${(props) => props.theme.colorBorder};
    border-top-color: ${(props) => props.theme.colorPrimary};
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  .location-distance-radius-input {
    padding-top: 5px;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
